var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boolean-expression-filter-editor"},[_c('div',{staticClass:"ref-select"},[_c('ExpressionEditor',_vm._b({model:{value:(_vm.expression),callback:function ($$v) {_vm.expression=$$v},expression:"expression"}},'ExpressionEditor',_vm.subObjectBinds,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }